export default __webpack_public_path__ + "static/media/home_header_bg.9f45f023.png";